(function () {
  'use strict';

  const blog = document.querySelector('.ops-blog');

  if (!blog) {
    return;
  }


  /* =========================================================
     HELPERS
     ========================================================= */

  function get(id) {
    return document.getElementById(id);
  }

  function setActive(buttons, activeButton) {
    buttons.forEach(function (button) {
      if (!button) return;

      button.classList.toggle(
        'is-active',
        button === activeButton
      );
    });
  }


  /* =========================================================
     DIE CUT DEMO
     ========================================================= */

  const DEFAULT_EXAMPLE =
    'https://cdn.shopify.com/s/files/1/0935/5352/5084/files/TeacupFrog.png?v=1752007999';

  const diecutShell = get('diecut-shell');
  const diecutPreview = get('diecut-preview');
  const diecutUpload = get('diecut-upload');
  const diecutFilename = get('diecut-filename');
  const diecutRemove = get('diecut-remove');
  const diecutRestore = get('diecut-restore');
  const diecutResetUpload = get('diecut-reset-upload');
  const diecutScale = get('diecut-scale');
  const diecutScaleReadout = get('diecut-scale-readout');

  const shapeNatural = get('ops-shape-natural');
  const shapeCircle = get('ops-shape-circle');
  const shapeOval = get('ops-shape-oval');
  const shapeSquare = get('ops-shape-square');

  const borderNone = get('ops-border-none');
  const borderWhite = get('ops-border-white');
  const borderBlack = get('ops-border-black');

  const shapeButtons = [
    shapeNatural,
    shapeCircle,
    shapeOval,
    shapeSquare
  ];

  const borderButtons = [
    borderNone,
    borderWhite,
    borderBlack
  ];

  let uploadedObjectURL = null;
  let processedObjectURL = null;
  let uploadedOriginal = null;


  function revokeProcessedURL() {
    if (!processedObjectURL) return;

    URL.revokeObjectURL(processedObjectURL);
    processedObjectURL = null;
  }


  function revokeUploadURL() {
    if (!uploadedObjectURL) return;

    URL.revokeObjectURL(uploadedObjectURL);
    uploadedObjectURL = null;
  }


  function setShape(shape, button) {
    if (!diecutShell) return;

    diecutShell.classList.remove(
      'shape-natural',
      'shape-circle',
      'shape-oval',
      'shape-square'
    );

    diecutShell.classList.add(
      'shape-' + shape
    );

    setActive(
      shapeButtons,
      button
    );
  }


  function setBorder(border, button) {
    if (!diecutShell) return;

    diecutShell.classList.remove(
      'border-none',
      'border-white',
      'border-black'
    );

    diecutShell.classList.add(
      'border-' + border
    );

    setActive(
      borderButtons,
      button
    );
  }


  function updateScale() {
    if (
      !diecutScale ||
      !diecutPreview ||
      !diecutScaleReadout
    ) {
      return;
    }

    const value =
      Number(diecutScale.value);

    diecutPreview.style.width =
      value + '%';

    diecutScaleReadout.textContent =
      value;
  }


  function resetExample() {
    if (
      !diecutPreview ||
      !diecutShell
    ) {
      return;
    }

    revokeProcessedURL();
    revokeUploadURL();

    uploadedOriginal = null;

    diecutPreview.src =
      DEFAULT_EXAMPLE;

    diecutShell.classList.add(
      'is-removed'
    );

    if (diecutUpload) {
      diecutUpload.value = '';
    }

    if (diecutFilename) {
      diecutFilename.textContent =
        'Showing our transparent example artwork.';
    }

    if (diecutScale) {
      diecutScale.value = 66;
    }

    setShape(
      'natural',
      shapeNatural
    );

    setBorder(
      'none',
      borderNone
    );

    updateScale();
  }


  function processBackground(source, callback) {

    const image =
      new Image();

    image.onload =
      function () {

        const maxDimension =
          600;

        const scale =
          Math.min(
            1,
            maxDimension /
            Math.max(
              image.naturalWidth,
              image.naturalHeight
            )
          );

        const canvas =
          document.createElement('canvas');

        canvas.width =
          Math.max(
            1,
            Math.round(
              image.naturalWidth * scale
            )
          );

        canvas.height =
          Math.max(
            1,
            Math.round(
              image.naturalHeight * scale
            )
          );

        const context =
          canvas.getContext(
            '2d',
            {
              alpha:true,
              willReadFrequently:true
            }
          );

        if (!context) {
          callback(source, true);
          return;
        }

        context.clearRect(
          0,
          0,
          canvas.width,
          canvas.height
        );

        context.drawImage(
          image,
          0,
          0,
          canvas.width,
          canvas.height
        );

        const imageData =
          context.getImageData(
            0,
            0,
            canvas.width,
            canvas.height
          );

        const data =
          imageData.data;

        let transparentFound =
          false;

        for (
          let index = 3;
          index < data.length;
          index += 16
        ) {

          if (data[index] < 245) {
            transparentFound = true;
            break;
          }

        }

        if (transparentFound) {
          callback(
            source,
            true
          );

          return;
        }

        for (
          let index = 0;
          index < data.length;
          index += 4
        ) {

          const red =
            data[index];

          const green =
            data[index + 1];

          const blue =
            data[index + 2];

          const alpha =
            data[index + 3];

          if (alpha === 0) {
            continue;
          }

          const brightness =
            (
              red +
              green +
              blue
            ) / 3;

          const spread =
            Math.max(
              red,
              green,
              blue
            ) -
            Math.min(
              red,
              green,
              blue
            );

          if (
            brightness >= 246 &&
            spread <= 18
          ) {

            data[index + 3] = 0;

          }
          else if (
            brightness >= 232 &&
            spread <= 20
          ) {

            data[index + 3] =
              Math.round(
                255 *
                (
                  (
                    246 -
                    brightness
                  ) /
                  14
                )
              );

          }

        }

        context.putImageData(
          imageData,
          0,
          0
        );

        canvas.toBlob(
          function (blob) {

            if (!blob) {
              callback(source, false);
              return;
            }

            revokeProcessedURL();

            processedObjectURL =
              URL.createObjectURL(blob);

            callback(
              processedObjectURL,
              false
            );

          },
          'image/png'
        );

      };

    image.onerror =
      function () {

        callback(
          source,
          true
        );

      };

    image.src = source;
  }


  if (diecutUpload) {

    diecutUpload.addEventListener(
      'change',
      function () {

        const file =
          diecutUpload.files &&
          diecutUpload.files[0];

        if (!file) {
          return;
        }

        revokeProcessedURL();
        revokeUploadURL();

        uploadedObjectURL =
          URL.createObjectURL(file);

        uploadedOriginal =
          uploadedObjectURL;

        diecutPreview.src =
          uploadedOriginal;

        diecutShell.classList.remove(
          'is-removed'
        );

        if (diecutFilename) {
          diecutFilename.textContent =
            file.name;
        }

        setShape(
          'natural',
          shapeNatural
        );

        setBorder(
          'none',
          borderNone
        );

      }
    );

  }


  if (diecutRemove) {

    diecutRemove.addEventListener(
      'click',
      function () {

        if (
          !diecutPreview ||
          !diecutShell
        ) {
          return;
        }

        if (!uploadedOriginal) {

          diecutPreview.src =
            DEFAULT_EXAMPLE;

          diecutShell.classList.add(
            'is-removed'
          );

          if (diecutFilename) {
            diecutFilename.textContent =
              'This example already has a transparent background.';
          }

          setShape(
            'natural',
            shapeNatural
          );

          return;
        }

        if (diecutFilename) {
          diecutFilename.textContent =
            'Preparing preview…';
        }

        requestAnimationFrame(
          function () {

            setTimeout(
              function () {

                processBackground(
                  uploadedOriginal,
                  function (
                    result,
                    alreadyTransparent
                  ) {

                    diecutPreview.src =
                      result;

                    diecutShell.classList.add(
                      'is-removed'
                    );

                    setShape(
                      'natural',
                      shapeNatural
                    );

                    if (!diecutFilename) {
                      return;
                    }

                    if (alreadyTransparent) {

                      diecutFilename.textContent =
                        'This image already has a transparent background.';

                    }
                    else {

                      diecutFilename.textContent =
                        'Light background removed for this preview.';

                    }

                  }
                );

              },
              20
            );

          }
        );

      }
    );

  }


  if (diecutRestore) {

    diecutRestore.addEventListener(
      'click',
      function () {

        if (
          !diecutPreview ||
          !diecutShell
        ) {
          return;
        }

        revokeProcessedURL();

        diecutPreview.src =
          uploadedOriginal ||
          DEFAULT_EXAMPLE;

        if (uploadedOriginal) {

          diecutShell.classList.remove(
            'is-removed'
          );

          if (diecutFilename) {
            diecutFilename.textContent =
              'Original image restored.';
          }

        }
        else {

          diecutShell.classList.add(
            'is-removed'
          );

          if (diecutFilename) {
            diecutFilename.textContent =
              'Showing our transparent example artwork.';
          }

        }

      }
    );

  }


  if (diecutResetUpload) {

    diecutResetUpload.addEventListener(
      'click',
      resetExample
    );

  }


  if (shapeNatural) {

    shapeNatural.addEventListener(
      'click',
      function () {
        setShape(
          'natural',
          shapeNatural
        );
      }
    );

  }


  if (shapeCircle) {

    shapeCircle.addEventListener(
      'click',
      function () {
        setShape(
          'circle',
          shapeCircle
        );
      }
    );

  }


  if (shapeOval) {

    shapeOval.addEventListener(
      'click',
      function () {
        setShape(
          'oval',
          shapeOval
        );
      }
    );

  }


  if (shapeSquare) {

    shapeSquare.addEventListener(
      'click',
      function () {
        setShape(
          'square',
          shapeSquare
        );
      }
    );

  }


  if (borderNone) {

    borderNone.addEventListener(
      'click',
      function () {
        setBorder(
          'none',
          borderNone
        );
      }
    );

  }


  if (borderWhite) {

    borderWhite.addEventListener(
      'click',
      function () {
        setBorder(
          'white',
          borderWhite
        );
      }
    );

  }


  if (borderBlack) {

    borderBlack.addEventListener(
      'click',
      function () {
        setBorder(
          'black',
          borderBlack
        );
      }
    );

  }


  if (diecutScale) {

    diecutScale.addEventListener(
      'input',
      updateScale
    );

    updateScale();

  }



  /* =========================================================
     STICKER SHEET DEMO
     ========================================================= */

  const SHEET_ARTWORK =
    'https://cdn.shopify.com/s/files/1/0935/5352/5084/files/logo_png_666ec3bd-245e-4880-8201-5f14544f5989.png?v=1785858025';

  const SHEET_LAYOUTS = [

    {
      columns:3,
      rows:5,
      label:'3 × 5',
      size:'Large'
    },

    {
      columns:4,
      rows:5,
      label:'4 × 5',
      size:'Medium / Large'
    },

    {
      columns:4,
      rows:6,
      label:'4 × 6',
      size:'Medium'
    },

    {
      columns:5,
      rows:7,
      label:'5 × 7',
      size:'Small / Medium'
    },

    {
      columns:6,
      rows:8,
      label:'6 × 8',
      size:'Small'
    }

  ];

  const sheetWrap =
    get('sheet-wrap');

  const sheetGrid =
    get('sheet-grid');

  const sheetToggle =
    get('sheet-toggle');

  const sheetSizePanel =
    get('sheet-size-panel');

  const sheetSize =
    get('sheet-size');

  const sheetSizeCopy =
    get('sheet-size-copy');

  const sheetBgWhite =
    get('ops-sheet-bg-white');

  const sheetBgRed =
    get('ops-sheet-bg-red');

  const sheetBgStripe =
    get('ops-sheet-bg-stripe');

  const sheetBgDark =
    get('ops-sheet-bg-dark');

  const sheetBgButtons = [
    sheetBgWhite,
    sheetBgRed,
    sheetBgStripe,
    sheetBgDark
  ];

  let sheetVisible =
    false;


  function createSheetSticker() {

    const wrapper =
      document.createElement('div');

    wrapper.className =
      'ops-sheet-sticker has-white';

    const image =
      document.createElement('img');

    image.src =
      SHEET_ARTWORK;

    image.alt = '';

    wrapper.appendChild(
      image
    );

    return wrapper;
  }


  function renderSheetLayout() {

    if (
      !sheetGrid ||
      !sheetSize
    ) {
      return;
    }

    if (!sheetVisible) {

      sheetGrid.innerHTML = '';

      sheetGrid.classList.remove(
        'is-visible'
      );

      return;
    }

    const index =
      Number(sheetSize.value);

    const layout =
      SHEET_LAYOUTS[index];

    if (!layout) {
      return;
    }

    const count =
      layout.columns *
      layout.rows;

    sheetGrid.innerHTML = '';

    sheetGrid.style.gridTemplateColumns =
      'repeat(' +
      layout.columns +
      ',1fr)';

    sheetGrid.style.gridTemplateRows =
      'repeat(' +
      layout.rows +
      ',1fr)';

    const gap =
      Math.max(
        3,
        9 - index
      );

    sheetGrid.style.gap =
      gap + 'px';

    for (
      let item = 0;
      item < count;
      item++
    ) {

      sheetGrid.appendChild(
        createSheetSticker()
      );

    }

    sheetGrid.classList.add(
      'is-visible'
    );

    if (sheetSizeCopy) {

      sheetSizeCopy.textContent =
        layout.label +
        ' · ' +
        count +
        ' stickers · ' +
        layout.size;

    }

  }


  function setSheetBackground(
    background,
    button
  ) {

    if (!sheetWrap) {
      return;
    }

    sheetWrap.classList.remove(
      'bg-white',
      'bg-red',
      'bg-stripe',
      'bg-dark'
    );

    sheetWrap.classList.add(
      'bg-' + background
    );

    setActive(
      sheetBgButtons,
      button
    );
  }


  if (sheetBgWhite) {

    sheetBgWhite.addEventListener(
      'click',
      function () {
        setSheetBackground(
          'white',
          sheetBgWhite
        );
      }
    );

  }


  if (sheetBgRed) {

    sheetBgRed.addEventListener(
      'click',
      function () {
        setSheetBackground(
          'red',
          sheetBgRed
        );
      }
    );

  }


  if (sheetBgStripe) {

    sheetBgStripe.addEventListener(
      'click',
      function () {
        setSheetBackground(
          'stripe',
          sheetBgStripe
        );
      }
    );

  }


  if (sheetBgDark) {

    sheetBgDark.addEventListener(
      'click',
      function () {
        setSheetBackground(
          'dark',
          sheetBgDark
        );
      }
    );

  }


  if (sheetToggle) {

    sheetToggle.addEventListener(
      'click',
      function () {

        sheetVisible =
          !sheetVisible;

        if (sheetVisible) {

          if (sheetSize) {
            sheetSize.value = 0;
          }

          if (sheetSizePanel) {
            sheetSizePanel.hidden = false;
          }

          sheetToggle.textContent =
            'Hide stickers';

          renderSheetLayout();

        }
        else {

          sheetToggle.textContent =
            'Show 3 × 5 layout';

          if (sheetSizePanel) {
            sheetSizePanel.hidden = true;
          }

          renderSheetLayout();

        }

      }
    );

  }


  if (sheetSize) {

    sheetSize.addEventListener(
      'input',
      renderSheetLayout
    );

  }


  /* =========================================================
     CLEANUP
     ========================================================= */

  window.addEventListener(
    'pagehide',
    function () {

      revokeProcessedURL();
      revokeUploadURL();

    }
  );

})();